import React, {useState} from 'react';
import {externalLinks} from "../../utils/routes";
import Pages from "../../components/layout/Pages";
import {concepts, Product} from "fearless-common";
import OrderableTable from "../../components/layout/OrderableTable";
import {backendEndpoints} from "../../libs/backendEndpoints";
import SearchInput from "../../components/SearchInput";
import {ColumnDef} from "@tanstack/react-table";
import Header from '../../components/Header';
import { Button } from 'fearless-common-ui';
import {PlusLg} from "react-bootstrap-icons";
import useTitle from "../../components/hooks/useTitle";
import CellRender from "../../components/layout/table/CellRender";

const columns: Array<ColumnDef<Product>> = [
  {id: 'id', accessorKey: 'id', header: 'ID', enableSorting: false},
  {id: 'name', accessorKey: 'name', header: 'Name', enableSorting: true},
  {id: 'stripe_id', accessorKey: 'stripe_id', header: 'Stripe ID', enableSorting: false},
  {id: 'description', accessorKey: 'description', header: 'Description', enableSorting: false},
  {id: 'created_at', accessorKey: 'created_at', header: 'Created at', cell: CellRender.Date, enableSorting: true },
]

export default function AdminProducts() {
  const [query, setQuery] = useState('');

  useTitle(`Admin Stripe products`);

  return (
    <Pages.Centred padded>
      <div className="d-flex align-items-center justify-content-between">
        <Header.Admin
          description={`The products below are registered in and synced from Stripe to ${concepts.CompanyName}.`}
        >
          <span className="me-3">Stripe products</span>
          <a href={externalLinks.newStripeProduct} target="_blank" rel="noreferrer">
            <Button>
              <PlusLg />
              add Product
            </Button>
          </a>
        </Header.Admin>
        <div>
          <SearchInput onChange={(e) => setQuery(e.target.value)}/>
        </div>
      </div>
      <OrderableTable
        baseEndpoint={backendEndpoints.getAdminProducts}
        memoisedColumns={columns}
        buildLink={(record) => externalLinks.stripeProduct(record.stripe_id)}
        pagination
        searchQuery={query}
      />
    </Pages.Centred>
  );
}

